import React, { useEffect } from "react";
import { MdLocationOn, MdCall } from "react-icons/md";
import { GrMail } from "react-icons/gr";
import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { GetUrl, PostUrl } from "../BaseUrl";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ExportToExcel } from "../ExportToExcel";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [links, setLinks] = useState([]);
  const [linkLoading, setLinkLoading] = useState(false);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const { user } = useSelector((state) => state.Auth);
  const { contact } = useSelector((state) => state.getContent);
  const { allProducts } = useSelector((state) => state.products);

  const { t } = useTranslation();

  const handleSubscribeNewsletter = (e) => {
    e.preventDefault();
    toast.dismiss();
    if (email === "") {
      return toast.error("Please Enter email");
    }
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      return toast.error("Please Enter valid email");
    }
    setLoading(true);
    PostUrl("newsletter", { data: { email } })
      .then((res) => {
        setEmail("");
        setLoading(false);
        toast.success(res?.data?.message);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    setLinkLoading(true);
    GetUrl("footer-links")
      .then((res) => {
        if (res.data?.status === "success") {
          setLinks(res.data.pages);
        } else {
          toast.error(res?.data?.message);
        }
        setLinkLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setLinkLoading(false);
      });
  }, []);
  return (
    <>
      <div className="grid items-start gap-5 px-5 py-5 text-lg font-medium xl:grid-cols-4 md:grid-cols-2 place-items-start bg-LIGHTGRAY xl:px-20 md:px-10 md:pt-10 md:pb-20 md:gap-10">
        {/* logo */}
        <div className="w-full">
          <Link to="/" className="inline-block">
            <img
              src={require("../assets/images/familymaid 1.png")}
              className="object-fill object-center md:w-44 w-fit h-fit"
            />
          </Link>
        </div>
        {/* details */}
        <div className="w-full space-y-3">
          <p className="flex items-start text-lg lg:text-2xl">
            {t("contact_us")}
          </p>
          <div className="flex items-center gap-2">
            <MdLocationOn className="text-3xl" />
            <p>{contact?.address}</p>
          </div>
          <div className="flex items-center gap-2">
            <GrMail className="text-2xl" />
            <a href="mailto:sales@dollarempirellc.com">{contact?.emailFm}</a>
          </div>
          <div className="flex items-center gap-2">
            <MdCall className="text-2xl" />
            <a href="tel:323-268-8999">{contact?.phone}</a>
          </div>
        </div>
        {/* links */}
        <div className="w-full space-y-3">
          <Link
            className="block transition-all duration-300 hover:pl-2 hover:border-l-4 hover:border-PRIMARY hover:text-PRIMARY"
            to="/contact-us"
            onClick={toTop}
          >
            {t("contact_us")}
          </Link>
          {linkLoading
            ? t("loading").concat("...")
            : !linkLoading &&
              links.length > 0 &&
              links.map((link) => (
                <Link
                  key={link?.title}
                  className="block transition-all duration-300 hover:pl-2 hover:border-l-4 hover:border-PRIMARY hover:text-PRIMARY"
                  to={`/${link?.url}`}
                  onClick={toTop}
                >
                  {link?.title}
                </Link>
              ))}
          <p className="text-black whitespace-nowrap">
            {user !== null &&
              allProducts !== undefined &&
              allProducts.length > 0 && (
                <ExportToExcel
                  apiData={allProducts}
                  fileName="AllProducts-DollarEmpire"
                />
              )}
          </p>
        </div>
        {/* subscibe */}
        <div className="w-full space-y-3">
          <p>{t("subscribe_to_our_newsletter")}</p>
          <form className="flex items-center w-full">
            <input
              type="email"
              className="w-2/3 h-10 pl-3 font-normal text-black outline-none"
              placeholder={t("Email Address")}
              name="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              type="submit"
              onClick={(e) => handleSubscribeNewsletter(e)}
              className="w-auto h-10 px-1 text-white duration-100 ease-linear bg-black hover:bg-PRIMARY"
              disabled={loading}
            >
              {loading ? t("Submitting").concat("...") : t("subscribe")}
            </button>
          </form>
        </div>
      </div>
      {/* bottom part */}
      <div className="w-full py-3 text-center text-white bg-black">
        Copyright © {new Date().getFullYear()} Dollar Empire LLC
      </div>
    </>
  );
};

export default Footer;
